import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/Layout.vue'

Vue.use(Router)

/**
 * constantRoutes
 *没有权限要求的基本页面
 *可以访问所有角色
 */
export const constantRouterMap = [
	{
	    path: '/index',
		meta: { title: '首页',icon:"s-tools" },
	    component: () => import('@/page/login/index'),
	},
	{
	    path: '/login',
		meta: { title: '登录',icon:"s-tools" },
	    component: () => import('@/page/login/login'),
	},
	// {
	//     path: '/register',
	// 	meta: { title: '注册',icon:"s-tools" },
	//     component: () => import('@/page/login/register'),
	// },
	// {
	//     path: '/forgot',
	// 	meta: { title: '忘记密码',icon:"s-tools" },
	//     component: () => import('@/page/login/forgot'),
	// },
	{
	    path: '/',
	    component: Layout,
	    meta: { title: '主页',icon:"s-home" },
	    children: [
	        {path: '/',component: () => import('@/page/Dashboard'),meta: { title: '主页'}},
	    ]
	},
	{
	    path: '/authorize_login',
	    meta: { title: '授权登录',icon:"s-tools" },
	    component: () => import('@/page/login/authorize_login'),
	},
]
/**
 * asyncRoutes
 * 需要根据用户角色动态加载的路由
 * path必须为唯一否则其他管理员生成路由可能会有bug。
 */
export var asyncRoutes = [
	{
		title:'任务管理',
	    path: '/jd_task/',
	    component: Layout,
	    meta: { title: '任务管理',icon:"present" },
	    children: [
	        {title:'发布任务',path: 'add',component: () => import('@/page/jd_task/add'),meta: { title: '发布任务'}},
	        {title:'任务列表',path: 'list',component: () => import('@/page/jd_task/list'),meta: { title: '任务列表'}},
			{title:'订单汇总',path: 'order_list',component: () => import('@/page/jd_task/order_list'),meta: { title: '订单汇总'}},
			{title:'投诉列表',path: 'complain_list',component: () => import('@/page/jd_task/complain_list'),meta: { title: '投诉列表'}},
			{title:'任务模板',path: 'task_tmpl',component: () => import('@/page/jd_task/task_tmpl'),meta: { title: '任务模板'}},
			{title:'收费标准',path: 'cost_list',component: () => import('@/page/jd_task/cost_list'),meta: { title: '收费标准'}},
	    ]
	},
	{
		title:'资金管理',
	    path: '/jd_task/',
	    component: Layout,
	    meta: { title: '资金管理',icon:"money" },
	    children: [
			{title:'充值',path: 'recharge_pay',component: () => import('@/page/jd_task/recharge_pay'),meta: { title: '充值'}},
			{title:'充值明细',path: 'recharge_list',component: () => import('@/page/jd_task/recharge_list'),meta: { title: '充值明细'}},
			{title:'资金明细',path: 'br_details',component: () => import('@/page/jd_task/br_details'),meta: { title: '资金明细'}},
	    ]
	},
	{
		title:'个人资料',
	    path: '/user/',
	    component: Layout,
	    meta: { title: '个人资料',icon:"user" },
	    children: [
			{title:'店铺',path: 'store',component: () => import('@/page/jd_task/store'),meta: { title: '店铺'}},
			{title:'基本信息',path: 'index',component: () => import('@/page/user/index'),meta: { title: '基本信息'}},
			{title:'账户安全',path: 'security',component: () => import('@/page/user/security'),meta: { title: '账户安全'}},
	    ]
	},
	{
		title:'消息',
	    path: '/jd_task/',
	    component: Layout,
	    meta: { title: '消息',icon:"s-home" },
	    children: [
			{title:'站内信',path: 'message',component: () => import('@/page/jd_task/message'),meta: { title: '站内信'}},
	    ]
	},
]
export default new Router({
    // mode: 'history', //后端支持可开
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap
})